exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed-top-selling {\n  position: fixed;\n  float: right !important;\n  /* top: 0; */\n  /* right: 0; */\n  /* left: 0; */\n  width: 37%;\n}\n.fixed-top-downpayment {\n  position: fixed;\n  float: right !important;\n  top: 48%;\n  /* right: 0; */\n  /* left: 0; */\n  width: 37%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a7a039e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Dashboard/Pages/Settings/Suppliers/Form.vue
// module id = frqC
// module chunks = 4